var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEatExp = function SvgEatExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    stroke: "#727582",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m2.872 2-.2 3.209a2 2 0 0 0 1.996 2.124h.204m2-5.333.201 3.209a2 2 0 0 1-1.996 2.124h-.205m0-2.333V2m0 5.333V14m8.46-3.667V2c-1.333.667-2.8 2.07-3 3.667-.199 1.596-.28 2.739-.311 3.667a.97.97 0 0 0 .978 1zm0 0V14"
  })));
};
export default SvgEatExp;